import type { BuildPeriodFromMonthParams, CostPeriod } from '../types';

const buildPeriodFromMonth = ({ month, now }: BuildPeriodFromMonthParams): CostPeriod => {
    const [yearText, monthText] = month.split('-');
    const year = Number(yearText);
    const monthIndex = Number(monthText) - 1;

    const startDate = `${yearText}-${monthText}-01`;
    const isCurrentMonth = now.getUTCFullYear() === year && now.getUTCMonth() === monthIndex;

    if (isCurrentMonth) {
        const day = String(now.getUTCDate()).padStart(2, '0');
        return {
            startDate,
            endDate: `${yearText}-${monthText}-${day}`,
        };
    }

    const lastDay = new Date(Date.UTC(year, monthIndex + 1, 0)).getUTCDate();
    return {
        startDate,
        endDate: `${yearText}-${monthText}-${String(lastDay).padStart(2, '0')}`,
    };
};

export default buildPeriodFromMonth;
